import StoneEdit from './StoneEdit'

export default StoneEdit
